/**
 * <product-card-custom>
 * Lightweight behaviour for the custom product card: a play/pause toggle for video media
 * and a visual wishlist toggle. Image hover-swap is handled in CSS.
 */
class ProductCardCustom extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('.pcc__video');
    this.playToggle = this.querySelector('.pcc__play-toggle');
    this.wishlist = this.querySelector('.pcc__wishlist');

    if (this.playToggle && this.video) {
      this.playToggle.addEventListener('click', this.#togglePlay);
      // The video's own events are the source of truth for the button state, so the
      // icon/aria always match reality even if autoplay is blocked or play() rejects.
      this.video.addEventListener('play', this.#syncPlayState);
      this.video.addEventListener('pause', this.#syncPlayState);
      this.#syncPlayState();
    }
    if (this.wishlist) {
      this.wishlist.addEventListener('click', this.#toggleWishlist);
    }
  }

  disconnectedCallback() {
    this.playToggle?.removeEventListener('click', this.#togglePlay);
    this.video?.removeEventListener('play', this.#syncPlayState);
    this.video?.removeEventListener('pause', this.#syncPlayState);
    this.wishlist?.removeEventListener('click', this.#toggleWishlist);
  }

  #togglePlay = (event) => {
    event.preventDefault();
    if (!this.video) return;
    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  };

  #syncPlayState = () => {
    if (!this.video || !this.playToggle) return;
    const playing = !this.video.paused;
    this.playToggle.dataset.playing = String(playing);
    this.playToggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
  };

  #toggleWishlist = () => {
    const pressed = this.wishlist.getAttribute('aria-pressed') === 'true';
    this.wishlist.setAttribute('aria-pressed', String(!pressed));
  };
}

if (!customElements.get('product-card-custom')) {
  customElements.define('product-card-custom', ProductCardCustom);
}
